import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  select(event) {
    const clicked = event.currentTarget
    this.buttonTargets.forEach(btn => btn.classList.toggle("active", btn === clicked))
    this.inputTarget.value = clicked.dataset.value
  }
}
